import { render, staticRenderFns } from "./CorrespondentContactEmail.vue?vue&type=template&id=3464d176"
import script from "./CorrespondentContactEmail.vue?vue&type=script&lang=js"
export * from "./CorrespondentContactEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports